import { createFileRoute, redirect } from '@tanstack/react-router'
import { MainLayout } from '../components/MainLayout'
import { FeesPage } from '../pages/FeesPage'
import { useAuthStore } from '../stores/auth-store'

export const Route = createFileRoute('/fees' as any)({
  component: () => (
    <MainLayout>
      <FeesPage />
    </MainLayout>
  ),
  beforeLoad: () => {
    const { isAuthenticated } = useAuthStore.getState()
    if (!isAuthenticated) throw redirect({ to: '/login' })
  },
})
